export { default as benefitType } from './benefitType';
export { default as childInformation } from './childInformation';
export { default as childAddress } from './childAddress';
export { default as childIdentification } from './childIdentification';
export { default as childContact } from './childContact';
export { default as childRelationship } from './childRelationship';
export { default as claimantRelationship } from './claimantRelationship';
export { default as yourHistory } from './yourHistory';
export { default as yourIdentification } from './yourIdentification';
export {
  default as yourInformation,
  pageTitle as yourInformationTitle,
} from './yourInformation';
export { default as yourContact } from './yourContact';
export { default as yourAddress } from './yourAddress';
export { default as claimantPersonalInformation } from './claimantPersonalInformation';
export { default as claimantContactInformation } from './claimantContactInformation';
